/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { Button } from '@mui/material';
/**
 * Action button implementation
 * @param {String} label - button label
 * @param {Boolean} disabled - manage button accessability
 * @param {Function} onClick - trigger when button action occurred
 * @param {String} variant - color variant of the button
 * @param {String} type - type of the button (succuss,warning,danger)
 * @param {String} color - specific color of the button
 * @returns
 */
const ActionButton = ({
  label,
  onClick,
  disabled,
  variant = 'contained',
  type = 'clear',
  color = 'primary',
  size = 'small',
  sx = {},
  id = '',
}) => (
  <Button
    type={type}
    variant={variant}
    color={color}
    onClick={onClick}
    disabled={disabled}
    size={size}
    sx={sx}
    id={id}
  >
    {label.toUpperCase()}
  </Button>
);
//
export default ActionButton;
